import Scrollto from "../../tools/scrollTo";
import SiteButton from "../../ui/SiteButton";
import { useNavigate } from "react-router-dom";
import "./news.scss";

const Center = () => {
  const navigate = useNavigate();

  return (
    <div className="containerNews">
      <h1 className="titleNews">Welcome to Mu Beginning</h1>
      <h3 className="section-heading">Season 6</h3>
      <p className="intro-text">
        Mu Beginning is a Season 6 Mu Online server. Create your account, download
        the client, and join the battle.
      </p>
      <div className="containerButtonsNews">
        <SiteButton onClick={() => navigate("/gameInfo")}>Game Info</SiteButton>
        <SiteButton variant="secondary" onClick={() => navigate("/events")}>
          Events
        </SiteButton>
        <SiteButton variant="ghost" onClick={() => navigate("/commands")}>
          Commands
        </SiteButton>
        <SiteButton variant="secondary" onClick={() => navigate("/buyitems")}>
          Items
        </SiteButton>
      </div>
      <Scrollto />
    </div>
  );
};

export default Center;
